/* Fantastick 8.0 — one calendar policy for category, manual, favorites and checkout entry. */
(function (w) {
  'use strict';
  if (w.FantastickSeason) return;
  const ZONE = 'Europe/Berlin', clocks = new WeakMap(), indexes = new WeakMap(), subscribers = new Set();
  const formatter = new Intl.DateTimeFormat('en-CA', { timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit' });
  let timer = 0;
  const monotonic = () => w.performance && typeof w.performance.now === 'function' ? w.performance.now() : Date.now();
  function time(config) {
    if (!clocks.has(config)) {
      const stamp = Number(config.serverTime) * 1000;
      clocks.set(config, { epoch: Number.isFinite(stamp) && stamp > 0 ? stamp : Date.now(), start: monotonic(), wall: Date.now() });
    }
    const c = clocks.get(config); return c.epoch + Math.max(0, monotonic() - c.start, Date.now() - c.wall);
  }
  function day(config, at) {
    const parts = Object.fromEntries(formatter.formatToParts(new Date(at == null ? time(config) : at)).map(part => [part.type, part.value]));
    return parts.year + '-' + parts.month + '-' + parts.day;
  }
  function parse(value) {
    if (value == null || value === '') return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    if (!match) return false;
    const y = Number(match[1]), m = Number(match[2]), d = Number(match[3]), check = new Date(Date.UTC(y, m - 1, d));
    return y >= 1900 && check.getUTCFullYear() === y && check.getUTCMonth() === m - 1 && check.getUTCDate() === d ? { y, m, d, iso: String(value) } : false;
  }
  function active(category, config, at) {
    const schedule = category.schedule || category, from = parse(schedule.from), until = parse(schedule.until);
    if (from === false || until === false) return false;
    if (!from && !until) return true;
    const today = day(config, at);
    if (schedule.repeatYearly === true) {
      const year = Number(today.slice(0, 4)), mmdd = Number(today.slice(5, 7)) * 100 + Number(today.slice(8));
      const key = date => date.m * 100 + Math.min(date.d, new Date(Date.UTC(year, date.m, 0)).getUTCDate());
      const a = from && key(from), b = until && key(until);
      if (from && until && a > b) return mmdd >= a || mmdd <= b;
      return (!from || mmdd >= a) && (!until || mmdd <= b);
    }
    if (from && until && from.iso > until.iso) return false;
    return (!from || today >= from.iso) && (!until || today <= until.iso);
  }
  function index(config) {
    if (indexes.has(config)) return indexes.get(config);
    const categories = new Map();
    (config.motifCatalog || []).forEach(c => { if (c.key !== 'manual') categories.set(c.key, { ...c, references: (c.motifs || []).map(m => m.key) }); });
    (config.seasonIndex && config.seasonIndex.categories || []).forEach(c => categories.set(c.key, c));
    const localByMotif = new Map();
    (config.motifCatalog || []).forEach(category => { if (category.key === 'manual') return; (category.motifs || []).forEach(motif => {
      if (!localByMotif.has(motif.key)) localByMotif.set(motif.key, []); localByMotif.get(motif.key).push(category);
    }); });
    const byMotif = new Map(); let complete = !config.seasonIndex || config.seasonIndex.complete !== false;
    categories.forEach(category => {
      if (category.truncated && (category.schedule?.from || category.schedule?.until)) complete = false;
      (category.references || []).forEach(key => { if (!byMotif.has(key)) byMotif.set(key, []); byMotif.get(key).push(category); });
    });
    const result = { byMotif, localByMotif, complete }; indexes.set(config, result); return result;
  }
  function motifActive(key, config, at) {
    if (!key || key === 'none' || !String(key).startsWith('meta:')) return true;
    const data = index(config); if (!data.complete) return false;
    const local = config.productId && data.localByMotif.get(key);
    if (local && !local.some(category => active(category, config, at))) return false;
    const memberships = data.byMotif.get(key);
    return !memberships || memberships.some(c => active(c, config, at));
  }
  function tick() {
    timer = 0;
    if (document.hidden) return;
    subscribers.forEach(sub => {
      const current = day(sub.config);
      if (current !== sub.day) { sub.day = current; try { sub.callback(); } catch (error) { w.console && w.console.error(error); } }
    });
    if (subscribers.size) timer = w.setTimeout(tick, 60000);
  }
  function subscribe(config, callback) {
    const sub = { config, callback, day: day(config) }; subscribers.add(sub);
    if (!timer && !document.hidden) timer = w.setTimeout(tick, 60000);
    return () => { subscribers.delete(sub); if (!subscribers.size && timer) { w.clearTimeout(timer); timer = 0; } };
  }
  document.addEventListener('visibilitychange', () => { if (timer) w.clearTimeout(timer); timer = 0; if (!document.hidden) tick(); });
  w.FantastickSeason = { version: '8.0.0', timeZone: ZONE, active, motifActive, day, subscribe, index };
})(window);
